export const DATA_FORMS_TYPES = {
  FORM_DATA: "[Forms] FORM_DATA",
  CLEAR_FORMDATA: "[Forms] CLEAR_FORMDATA",
  UPDATE_FORM_DATA: "[Forms] UPDATE_FORM_DATA"
};
